const strings = {
  START_TIME: 'Starttid',
  END_TIME: 'Sluttid',
  NEW_USER: 'Ny användare',
  NEW_USER_INFO:
    'Vill du ladda ner manualen och ge den till den nya användaren eller skapa kontot själv?',
  CREATE_NEW_USER: 'Skapa själv',
  CANCEL: 'Avbryt',
  DELETE_LAUNDRY_TIME: 'Ta bort tvättid',
  DELETE_LAUNDRY_TIME_INFO:
    'Är du säker på att du vill ta bort tvättiden? Detta kan inte göras ogjort.',
  YES: 'Ja',
  NO: 'Nej',
  MANAGE_GENERAL_SETTINGS: 'Hantera allmänna inställningar',
  LAUDRY_TYPE: 'Tvättstugor eller tvättmaskiner?',
  LAUNDRIES: {
    S: 'Tvättstugor',
    M: 'Tvättmaskiner'
  },
  NO_LIMIT: 'Ingen gräns',
  LAUNDRY_TIME_AT_A_TIME: 'tvättid åt gången',
  LAUNDRY_TIMES_AT_A_TIME: 'tvättider åt gången',
  WEEKS: 'veckor',
  WEEK: 'vecka',
  MANAGE_GENERAL_BOOKING_SYSTEMS: 'Hantera bokningssystem',
  MANAGE_GENERAL_BOOKING_SYSTEMS_INFO:
    'Här kan din förening lägga till fler bokningssystem såsom bokning av bastu, grill eller liknande.',
  NEW_BOOKING_SYSTEM: 'Nytt bokningssystem',
  BOOKING_RANGE: 'Framtidsbokning',
  MAX_BOOKINGS: 'Max antal bokningar',
  TIMES: 'Bokningsbara tider',
  DELETE_BOOKING_SYSTEM: 'Ta bort bokningssystemet ',
  DELETE_BOOKING_SYSTEM_INFO:
    'Är du säker på att du vill ta bort bokningssystemet? Alla bokningar som tillhör systemet kommer att tas bort. Detta kan inte göras ogjort.',
  DELETE_BOOKING_SYSTEM_TIME: 'Ta bort bokningsbar tid',
  DELETE_BOOKING_SYSTEM_TIME_INFO:
    'Är du säker på att du vill ta bort passet? Alla bokningar som tillhör passet kommer att tas bort. Detta kan inte göras ogjort.'
}

export default strings



// WEBPACK FOOTER //
// ./src/components/containers/BookingSystemsTable/strings.js